import { orderActionTypes } from '../app/enums';
import { OrderContextType } from '../context/OrderContext';
import { VehicleInfo } from '../models/cart.interface';
import { Order } from '../models/order.interface';
import { SearchType } from '../models/search.interface';

export type OrderAction =
  | { type: orderActionTypes.LOAD_ORDER, order: Order} 
  | { type: orderActionTypes.LOAD_SEARCH_INFO, search: SearchType, orderItemId: string }
  | { type: orderActionTypes.LOAD_ORDER_LIST, orderList: Order[] }
  | { type: 'field'; fieldName: string; payload: string };

export const loadOrder = (state: OrderContextType, order: Order) => {
  let itemCount = 0;
  let totalAmount = 0;

  if(order.items !== undefined && order.items.length > 0){
    order.items.forEach((item) => {
      itemCount = itemCount + item.quantity
      totalAmount = totalAmount + (item.price * item.quantity)
    })
  }

  state.itemCount = itemCount
  state.totalAmount = totalAmount

  return {
    ...state,
    itemCount: itemCount,
    totalAmount: totalAmount,
    displayOrder: order
  };
}

export const loadSearch = (state: OrderContextType, search: SearchType, id: string) => {
  let displayOrder = state.displayOrder
  const orderItems = displayOrder.items

  const updatedIndex = orderItems.findIndex(
    item => item.id === id
  )
    
  let updatedItem = orderItems[updatedIndex]

  const vehicleInfo: VehicleInfo = {
    year: search.year,
    make: search.make,
    model: search.model,
    vin: search.vin
  }

  updatedItem = {
    ...updatedItem,
    vehicleInfo: vehicleInfo
  }

  orderItems[updatedIndex] = updatedItem

  displayOrder = {
    ...displayOrder,
    items: orderItems
  }

  return {
    ...state,
    displayOrder: displayOrder
  };
}

export const loadOrderList = (state: OrderContextType, orderList: Order[]) => {
  return {
    ...state,
    orderList: orderList
  };
}

const updateField = (state: OrderContextType, fieldName: string, payload: string) => {
  return {
    ...state,
    [fieldName]: payload
  }
}

export const orderReducer = (state: OrderContextType, action:OrderAction) => {
  switch (action.type){
    case 'field': 
      return updateField(state, action.fieldName, action.payload)
    case orderActionTypes.LOAD_ORDER:
      return loadOrder(state, action.order)
    case orderActionTypes.LOAD_SEARCH_INFO:
      return loadSearch(state, action.search, action.orderItemId);
    case orderActionTypes.LOAD_ORDER_LIST:
      return loadOrderList(state, action.orderList.sort((orderA, orderB) => 
        (new Date(orderB.createdAt)).getTime() - (new Date(orderA.createdAt)).getTime()));
    default:
      return state;
  }
}
  